import { createRoot } from "react-dom/client";
import "@/styles/index.scss";
import "@/i18n.ts";
import App from "./App";
import { ApolloProvider } from "@apollo/client";
import { apolloClient } from "@/apollo/apolloClient";

const root = createRoot(document.getElementById("root")!);

root.render(
  <ApolloProvider client={apolloClient}>
    <App />
  </ApolloProvider>
);
